var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{attrs:{"title":_vm.doc.name,"close":"","disabled":_vm.disabled},on:{"click:close":_vm.onRemove}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon()))]),_vm._v(" "+_vm._s(_vm.name(_vm.doc.name))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }